if (!customElements.get('product-grid-gallery')) {
    class ProductPageGridGallery extends HTMLElement {
        static observedAttributes = ['data-size'];
        sizeCounter = 0;

        constructor() {
            super();
            this.setupNavigationButtons();
        }

        gridCellSelector() {
            return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
        }

        allGridCells() {
            return this.gridCellSelector() ? Array.from(this.querySelectorAll(this.gridCellSelector())) : Array.from(this.children);
        }

        getVisibleCells() {
            return this.allGridCells().filter(cell => !cell.hasAttribute('hidden'));
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue !== newValue) {
                this.setAttribute(name, newValue);
            }
        }

        setupNavigationButtons() {
            const parent = this.closest('.relative');
            if (!parent) return;

            const prevButton = parent.querySelector('.product-gallery-nav-prev');
            const nextButton = parent.querySelector('.product-gallery-nav-next');

            if (prevButton && nextButton) {
                prevButton.addEventListener('click', () => this.scrollBy({ left: -this.offsetWidth, behavior: 'smooth' }));
                nextButton.addEventListener('click', () => this.scrollBy({ left: this.offsetWidth, behavior: 'smooth' }));

                this.addEventListener('scroll', () => this.updateNavigationState());
                this.updateNavigationState();
            }
        }

        updateNavigationState() {
            const parent = this.closest('.relative');
            if (!parent) return;

            const prevButton = parent.querySelector('.product-gallery-nav-prev');
            const nextButton = parent.querySelector('.product-gallery-nav-next');

            if (prevButton && nextButton) {
                prevButton.disabled = this.scrollLeft <= 0;
                nextButton.disabled = this.scrollLeft >= this.scrollWidth - this.offsetWidth - 1;
            }
        }

        filter(indexes = []) {
            const gridCells = this.allGridCells();
            const fullScreenButtons = document.querySelectorAll('.product-gallery__thumbnail');

            fullScreenButtons.forEach((media, index) => {
                media.toggleAttribute('hidden', indexes.includes(index));
            });

            let visibleCount = 0;
            let thirdActiveCell = null;

            gridCells.forEach((cell, index) => {
                const isHidden = indexes.includes(index);
                cell.toggleAttribute('hidden', isHidden);
                cell.removeAttribute('data-is-third-active');

                if (!isHidden) {
                    visibleCount += 1;
                    if (visibleCount === 3) {
                        thirdActiveCell = cell;
                    }
                }
            });

            if (thirdActiveCell) {
                thirdActiveCell.setAttribute('data-is-third-active', 'true');
            }

            this.dispatchEvent(new CustomEvent("carousel:filter", {
                detail: { filteredIndexes: indexes }
            }));
            this.sizeCounter = gridCells.length - indexes.length;
            this.setAttribute('data-size', this.sizeCounter);
            setTimeout(() => this.updateNavigationState(), 0);
        }
    }

    customElements.define('product-grid-gallery', ProductPageGridGallery);
}
